import { render, staticRenderFns, recyclableRender, components } from "./real-exam.vue?vue&type=template&id=599d8439&scoped=true&"
var renderjs
import script from "./real-exam.vue?vue&type=script&lang=js&"
export * from "./real-exam.vue?vue&type=script&lang=js&"
import style0 from "./real-exam.vue?vue&type=style&index=0&id=599d8439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d8439",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/real-exam.vue"
export default component.exports